import React, { useEffect, useState } from "react";
import { makeRequest } from "../../api";
import { toast } from "react-toastify";
import { successToaster, warningToaster } from "../../Data/Data";
import CircularProgressLoader from "../CircularProgressLoader";

const UnableUnidentifyTigers = ({
  selectedTiger,
  setIsUnableMode,
  onUnableIdentified,
  selectedMatchedTiger,
  setSelectedMatchedTiger,
  setUnIdentifiedTigers,
  unIdentifiedTigers,
}) => {
  const [loading, setLoading] = useState(false);
  const [unableToIdentifyTigerData, setUnableToIdentifyTigerData] = useState(
    []
  );

  useEffect(() => {
    fetchUnableImages();
  }, []);

  const handleTigerSelection = (tiger) => {
    setLoading(true);
    setSelectedMatchedTiger(tiger);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const fetchUnableImages = async () => {
    setLoading(true);

    try {
      let token = "";
      if (localStorage.token) {
        token = localStorage.token;
      }

      // Define the data to send in the request body
      const data = { id: selectedTiger.id };

      // Make the API call using your existing makeRequest function
      const response = await makeRequest(
        "post",
        `api/v1/identification/tiger_images_unidentified/`,
        data
      );

      // Handle the response
      if (response.data && response.data.data.length > 0) {
        const tigerData = response.data.data;
        setUnableToIdentifyTigerData(tigerData);
        setSelectedMatchedTiger(tigerData[0]);
      } else {
        toast.success("No unidentified tigers found", warningToaster);
      }
    } catch (error) {
      toast.success(
        "Failed to fetch unidentified tiger images",
        warningToaster
      );
    } finally {
      setLoading(false);
    }
  };

  const handleIdentify = async () => {
    if (!selectedMatchedTiger || !selectedTiger) {
      toast.error(
        "Please select a matched tiger and an uploaded tiger image.",
        warningToaster
      );
      return;
    }

    try {
      let token = "";
      if (localStorage.token) {
        token = localStorage.token;
      }

      const data = {
        image_id: selectedTiger.id,
        tiger_id: selectedMatchedTiger.id,
        origin: "upload",
      };

      const response = await makeRequest(
        "post",
        `api/v1/identification/tiger_identify`,
        data
      );

      if (response.data && response.data.data.success) {
        toast.success("Tiger successfully identified!", successToaster);
        const updatedData = unIdentifiedTigers.map((tiger) =>
          tiger.id === selectedTiger.id
            ? {
                ...tiger,
                checked: true,
                species_name: selectedMatchedTiger.name,
              }
            : tiger
        );
        setUnIdentifiedTigers(updatedData);
        onUnableIdentified();
      } else {
        toast.error(
          "Failed to identify the tiger. Please try again.",
          warningToaster
        );
      }
    } catch (error) {
      console.error("Error identifying tiger:", error);
      toast.error(
        "An error occurred while identifying the tiger.",
        warningToaster
      );
    } finally {
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1vh",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "6vh",
          }}
        >
          <CircularProgressLoader className="loading-spinner" size={50} />
          <p>Loading Tiger Data...</p>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <div
            style={{
              width: "50%",
              display: "flex",
              height: "15vh",
              overflow: "auto",
              flexWrap: "wrap",
              marginTop: "2vh",
            }}
          >
            {unableToIdentifyTigerData.map((tiger) => (
              <button
                key={tiger.id}
                style={{
                  opacity:
                    selectedMatchedTiger && selectedMatchedTiger.id === tiger.id
                      ? 1
                      : 0.5,
                  backgroundColor: "#e67817",
                  color: "white",
                  padding: "10px",
                  margin: "5px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  width: "6vw",
                }}
                onClick={() => handleTigerSelection(tiger)}
              >
                {tiger.name}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: "1vw", marginTop: "2vh" }}>
            <button
              className="DeleteButton"
              onClick={() => setIsUnableMode(false)}
            >
              Back
            </button>
            <button className="DeleteButton" onClick={handleIdentify}>
              Identify
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UnableUnidentifyTigers;
